import { render, staticRenderFns } from "./BaseInputQuotas.vue?vue&type=template&id=0b87f527&scoped=true&"
import script from "./BaseInputQuotas.vue?vue&type=script&lang=js&"
export * from "./BaseInputQuotas.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputQuotas.vue?vue&type=style&index=0&id=0b87f527&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87f527",
  null
  
)

export default component.exports